import script from "./FloatingMessageIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatingMessageIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./FloatingMessageIndicator.vue?vue&type=style&index=0&id=8f15939e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f15939e"]])

export default __exports__